module.exports = __webpack_public_path__ + "img/H2.4b910b0c.png";